import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 24px 24px 24px;
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: left;
`;

export const ModalSubtitle = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 16px;
  `}
`;

export const ModalButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column-reverse;
      align-items: stretch;
    }
  `}
`;
